import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from "react-redux";
import {Box, MenuItem, Select} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";
import {isArray} from "underscore";
// import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
// import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
// import IconButton from '@material-ui/core/IconButton';
import {getTitle} from '../../shared/vehicle';
import * as actions from "../../store/actions";


const useStyles = makeStyles((theme) => ({

    dashboard: {
        color: grey[500],
    },
    dashboardItem: {
        border: 1,
        borderColor: grey[500],
        borderStyle: "solid",
        padding: theme.spacing(2)
    },
    dashboardItem2: {
        border: 1,
        borderColor: grey[500],
        borderStyle: "solid",
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    icon: {
        marginRight: theme.spacing(2)
    },
    iconButton: {
        paddingRight: '0px'
    },
    box: {
        display: 'flex',
        justifyContent: 'left',
        paddingBottom: '10px'
    },
    selectVehicle: {
        fontSize: '18px',
        fontWeight: '500',
        '&.MuiInput-underline:before,&.MuiInput-underline:after,&.MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: '0'
        }
    }
}));

const VehicleSelector = (props) => {

    const classes = useStyles();

    let vehicleSelector = (<React.Fragment></React.Fragment>)
    if (isArray(props.vehicles) && props.vehicles.length > 1) {
        const vehicle = props.vehicles[props.selectedVehicleIndex];
        if (vehicle) {
            // vehicleSelector = (
            //     <Box display="flex" justifyContent="center">
            //         <IconButton classes={{ root: classes.iconButton }} onClick={() => props.onPrev()}><KeyboardArrowLeft/></IconButton>
            //         {getTitle(vehicle)}
            //         <IconButton classes={{ root: classes.iconButton }} onClick={() => props.onNext()}><KeyboardArrowRight/></IconButton>
            //     </Box>
            // )

            vehicleSelector = (
                <Box className={classes.box}>
                    <Select className={classes.selectVehicle} defaultValue={vehicle.id} 
                        onChange={(e) => props.changeVehicle(e.target.value)}>
                        {props.vehicles.map(item => {
                            return (<MenuItem key={item.id} value={item.id}>{getTitle(item)}</MenuItem>);
                        })}
                    </Select>
                </Box>
            );
        }

    }
    return vehicleSelector
}

const mapStateToProps = state => {
    return {
        account: state.account,
        // vehicles: state.vehicles,
        selectedVehicleIndex: state.app.selectedVehicleIndex
    };
};

const mapDispatchToProps = dispatch => {
    return {
        // onNext: () => dispatch(actions.changeVehicle(1)),
        // onPrev: () => dispatch(actions.changeVehicle(0)),
        changeVehicle: (id) => dispatch(actions.changeVehicleById(id)) 
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleSelector);